export default __webpack_public_path__ + "static/media/Section2-main.b8aef1a0.svg";